import { render, staticRenderFns } from "./ComponentsList.vue?vue&type=template&id=32fe6873&scoped=true"
import script from "./ComponentsList.vue?vue&type=script&lang=js"
export * from "./ComponentsList.vue?vue&type=script&lang=js"
import style0 from "./ComponentsList.vue?vue&type=style&index=0&id=32fe6873&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fe6873",
  null
  
)

export default component.exports